<template>
	<div class="eip-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('eip.text.eip')" @back="jumpToUp()" class="relative">
				<template slot="content">
					<span class="long-name" :title="gridData.elasticIp">
						{{ gridData.elasticIp }}
					</span>
					<div class="jc-list__header--right jc-box-action">
						<a v-bind:href="Config.EIP_URL" target="_blank">{{ $t('eip.help.doc') }}</a>
						<!--操作-->
						<drop-down-operation :operations="availableOperatesArray" @clickSelectItem="selectOps"
							:buttonTitle="$t('privateNetwork.operate')">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" v-model="tabName">
				<!--资源信息-->
				<el-tab-pane :label="$t('detail.text.sourceInfo')" name="sourceInfo" :disabled="tabName === 'sourceInfo'">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--ID-->
										<el-form-item :label="$t('detail.text.id') | withColon">
											<p>
												<span>{{ gridData.elasticIpId | maybeEmpty }}</span>
                        <copy-value :copyVal="`${gridData.elasticIpId}`"></copy-value>
												<!-- <span @mouseout="copyHover = false">
													<el-button :disabled="gridData.elasticIpId === undefined"
														v-clipboard:copy="elasticIpId" v-clipboard:success="copyToClipboard"
														v-clipboard:error="failToCopy" id="copy-button" type="text"
														icon="el-icon-document-copy">
													</el-button>
												</span> -->
											</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--IP地址-->
										<el-form-item :label="$t('eip.text.ipAddress') | withColon"
											class="jc-form-description">
											<p>{{ gridData.elasticIp | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--地域-->
										<el-form-item :label="$t('create.text.region') | withColon">
											<p>{{ regions[gridData.region] | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--可用区-->
										<el-form-item :label="$t('create.text.az') | withColon">
											<p>{{ $t('eip.text.allAz') }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--线路-->
										<el-form-item :label="$t('eip.text.line') | withColon" class="editDescription">
											<span class="desc-span">
												{{ gridData.lineType ? gridData.lineTypeName : '' | maybeEmpty }}
											</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--带宽上限-->
										<el-form-item :label="$t('eip.text.bandwidthLimit') | withColon">
											<span>{{ gridData.bandwidth + 'Mbps' }}</span>
											<span>
												{{ gridData.bandwidthPackageId ? $t('eip.text.bandwidthPackage') :
													$t('eip.text.independentBandwidth') }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8" v-if="gridData.bandwidthPackageId">
										<!--已加入共享带宽-->
										<el-form-item :label="$t('eip.text.alreadyJoinedSharedBandwidth') | withColon">
											<a href="javascript:void(0)"
												@click="jumpToDetail(gridData.bandwidthPackageId, gridData.region)">
												{{ gridData.bandwidthPackageName }}
											</a>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!-- 标签 -->
										<el-form-item :label="$t('listPage.text.tags') | withColon" class="edit-jc-form">
											<span class="instance-name" :title="gridData.tagPairs">{{ gridData.tagPairs |
												maybeEmpty }}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!--计费信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--计费类型-->
										<el-form-item :label="$t('detail.text.billingType') | withColon">
											<p>{{ gridData.chargeModeName | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--申请时间-->
										<el-form-item :label="$t('eip.text.applyTime') | withColon">
											<p>{{ gridData.charge ? gridData.charge.chargeStartTime : '' | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--到期时间（计费类型为包年包月时显示）-->
										<el-form-item :label="$t('detail.text.expireTime') | withColon" v-if="gridData.chargeMode
											=== ChargeModeConstant.PREPAID_BY_DURATION">
											<p>{{ gridData.charge ? gridData.charge.chargeExpiredTime : '' | maybeEmpty }}
											</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!--绑定资源信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.bindSourceInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--实例类型-->
										<el-form-item :label="$t('eip.text.instanceType') | withColon">
											<p> {{ gridData.instanceType ?
												InstanceTypeConstant[gridData.instanceType.toUpperCase()] : '' |
												maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--实例名称-->
										<el-form-item :label="$t('detail.text.name') | withColon">
											<p class="english-word-wrap" :title="gridData.instanceName | maybeEmpty">
												{{ gridData.instanceName | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--关联网口-->
										<el-form-item :label="$t('eip.text.relativeNetworkInterface') | withColon">
											<p class="english-word-wrap" :title="relativeNetworkInterface">
												{{ relativeNetworkInterface }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--IP地址-->
										<el-form-item :label="$t('eip.text.ipAddress') | withColon">
											<p class="english-word-wrap" :title="gridData.targetIp">
												{{ targetIp(gridData) }}
											</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!--监控-->
				<el-tab-pane :label="$t('detail.text.monitor')" name="performanceMonitor"
					:disabled="tabName === 'performanceMonitor'">
					<performance-monitor v-if="tabName === 'performanceMonitor'" :regionId="region"
						:resourceId="elasticIpId" :metrics="metrics"
						:service-code="ServiceCodeConstant.CPSEIP"></performance-monitor>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div v-if="copyHover" class="jc-tooltip__popper is-dark copy-success" x-placement="bottom">{{
			$t('detail.text.copySuccess') }}
			<div class="popper__arrow copy-success-arrow"></div>
		</div>
		<bind-source :dialog-visible="bindDialogVisible" @ifDialogVisible="syncBindDialogVisibleData"
			:eip-id="gridData.elasticIpId" :region="gridData.region" @refreshList="getServerData"></bind-source>
		<!--解绑资源-->
		<un-bind-source :visible.sync="unBindSourcedDialogVisible" @ifDialogVisible="syncUnbindDialog" :region="region"
			:rowInfo="gridData" @refresh="getServerData">
		</un-bind-source>
		<modify-bandwidth :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialogVisibleData"
			:detailData="gridData">
		</modify-bandwidth>
		<!--加入共享带宽-->
		<join-sharebandwidth :dialog-visible.sync="joinShareBandwidthDialogVisible" :detail-data="gridData" :region="region"
			@refreshPage="getServerData">
		</join-sharebandwidth>
		<!-- 编辑标签 -->
		<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSEIP"
			:region-id="gridData.region ? gridData.region : ''"
			:resource-ids="gridData.elasticIpId ? [gridData.elasticIpId] : []" @complete="getServerData">
		</jcb-tag-edit>
		<!--删除eip-->
		<delete-eip :visible.sync="deleteEipVisible" @refresh="goBack" :rowInfo="gridData" :pageSource="'detail'">
		</delete-eip>
	</div>
</template>

<script>
import {
	ChargeModeMap,
	EipOperationConstant,
	EIPAssociateConstant,
	InstanceTypeConstant,
	OverdueConstantArray,
	ServiceCodeConstant,
	ChargeModeConstant,
	NetworkTypeConstant
} from '@/common/Constants';
import BindSource from '@/components/eip/bindSource/BindSource';
import UnBindSource from '@/components/eip/UnBindSource';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import JoinSharebandwidth from '@/components/common/joinShareBandwidth/JoinShareBandwidth';
import DeleteEip from '@/components/common/DeleteEip';
import { operations } from '@/common/EipPopHelper';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import PerformanceMonitor from '@/components/common/PerformanceMonitor/Monitor';
import { guid } from "@/common/tool";
import copyValue from '@/components/privateNetwork/CopyValue';
export default {
	components: {
		BindSource,
		UnBindSource,
		ModifyBandwidth,
		JoinSharebandwidth,
		dropDownOperation,
		DeleteEip,
		PerformanceMonitor,
    copyValue
	},
	data() {
		this.metrics = [
			{ include: ['cpseip.ingress.bandwidth'], guid: guid() },
			{ include: ['cpseip.egress.bandwidth'], guid: guid() },
			{ include: ['cpseip.ingress.pkgsrate'], guid: guid() },
			{ include: ['cpseip.egress.pkgsrate'], guid: guid() },
			{ include: ['cpseip.ingress.usage'], guid: guid() },
			{ include: ['cpseip.egress.usage'], guid: guid() },
			{ include: ['cpseip.ingress.bytes'], guid: guid() },
			{ include: ['cpseip.egress.bytes'], guid: guid() },
			{ include: ['cpseip.ingress.pkgdroprate'], guid: guid() },
			{ include: ['cpseip.egress.pkgdroprate'], guid: guid() },
		];
		return {
			tabName: 'sourceInfo',
			elasticIpId: '',
			// 支持的操作
			operatesArr: [
				'BIND', // 绑定资源
				'UNBIND', // 解绑资源
				'MODIFY', // 修改带宽
				'JOINSHARED', //加入共享带宽
				'REMOVESHARED', //移除共享带宽
				'RENEW', // 续费
				'EDITTAG',//编辑标签
				'DELETE', // 删除
			],
			// 当前EIP支持的操作
			availableOperatesArray: [],
			selectOperate: '1',
			gridData: {},
			descriptionFlag: false,
			editObj: {
				editName: '',
				editDescription: ''
			},
			region: '',
			regions: {},
			copyHover: false,
			// 子网对应的云物理服务器列表
			subnetInstanceListData: [],
			// 云物理服务器tab页loading状态
			tableListLoading: false,
			// 云物理服务器个数
			total: 0,
			// 绑定资源弹框是否可见
			bindDialogVisible: false,
			// 解绑资源弹框是否可见
			unBindSourcedDialogVisible: false,
			// 修改带宽弹框是否可见
			modifyDialogVisible: false,
			// 加入共享带宽弹框是否可见
			joinShareBandwidthDialogVisible: false,
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 删除eip弹框
			deleteEipVisible: false,
		};
	},
	computed: {
		ChargeModeMap: () => ChargeModeMap,
		EIPAssociateConstant: () => EIPAssociateConstant,
		ServiceCodeConstant: () => ServiceCodeConstant,
		InstanceTypeConstant: () => InstanceTypeConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
		targetIp: () => {
			return function (data) {
				let targetIp = data.targetIp;
				let aliasIp = data.aliasIp;
				if (targetIp) {
					return `${targetIp}(${this.$t('subnet.text.privateIp')})`
				}
				if (aliasIp) {
					return `${aliasIp}(${this.$t('subnet.text.ipAlias')})`
				}
				return '--'
			}
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus() {
			if (OverdueConstantArray.includes(this.gridData.charge.chargeStatus)
				&& this.gridData.charge.chargeRetireTime) {
				return true;
			}
			return false;
		},
		relativeNetworkInterface() {
			let interfaceMode = this.gridData.interfaceMode;
			if (interfaceMode === 'dual') {
				return this.$t('create.text.chiefAndSubInternetAccessName')
			} else if (interfaceMode === 'bond') {
				return this.$t('create.text.singleInternetAccessChiefName')
			} else {
				return '--'
			}
		},

	},
	watch: {},
	async created() {
		this.elasticIpId = this.$route.params.id;
		this.region = this.$route.params.region;
		this.az = this.$route.params.az;
		// 获取资源信息tab页数据
		await this.getRegions();
		this.getServerData(true);
	},
	methods: {
		/**
			* 获得region和regionName对照
		*/
		getRegions() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			return Ajax.get('api/cps/getRegions', params).then((res) => {
				if (res.data) {
					res.data.regions.forEach((region) => {
						this.regions[region.region] = region.regionName;
					});
				}
			});
		},
		getRegionName(region) {
			let regionName = this.regions[region];
			return regionName;
		},
		getServerData() {
			const target = this;
			Ajax.get({
				action: '/elasticIps',
				param: {
					elasticIpId: target.elasticIpId,
					region: target.region
				},
				success: (data) => {
					const tagPairs = data.elasticIp.tags;
					target.gridData = data.elasticIp;
					//格式化计费信息数据
					if (Object.keys(target.gridData.charge).length === 0) {
						target.gridData.chargeModeName = ''
					} else {
						target.gridData.chargeModeName =
							target.ChargeModeMap[target.gridData.charge.chargeMode.toUpperCase()];
					}
					target.gridData.chargeMode = target.gridData.charge.chargeMode;
					target.eipStatus = data.elasticIp.status;
					target.gridData.tagPairs = '';
					if (tagPairs !== undefined) {
						if (tagPairs.length > 0) {
							for (const tag of tagPairs) {
								target.gridData.tagPairs += `${tag.key}:${tag.value},`;
							}
							target.gridData.tagPairs = target.gridData.tagPairs.substring(0, target.gridData.tagPairs.length - 1);
						}
					}
					this.initOperates();
				}
			});
		},
		// 操作下拉选初始化，绑定、解绑、调整带宽、续费、编辑标签、删除
		initOperates() {
			this.availableOperatesArray = this.operatesArr.map((key) => {
				const { name } = this.$t(`eip.operations.${key.toString().toLowerCase()}`);
				const item = {
					value: EipOperationConstant[key],
					operateName: name,
					ifShow: true,
					disabled: false
				};
				if (key === 'MODIFY' && this.gridData.bandwidthPackageId) {
					item.disabled = true;
					item.tip = this.$t('eip.help.joinSharedBandwidthNotAllowedModify');
				}
				if (key === 'BIND' && this.eipStatus === EIPAssociateConstant.ASSOCIATE) {
					item.ifShow = false;
				}
				if (key === 'UNBIND' && this.eipStatus === EIPAssociateConstant.DISASSOCIATE) {
					item.ifShow = false;
				}
				if (key === 'JOINSHARED' && this.gridData.bandwidthPackageId) {
					item.ifShow = false;
				}
				if (key === 'JOINSHARED' && this.gridData.chargeMode
					=== this.ChargeModeConstant.PREPAID_BY_DURATION && !this.gridData.bandwidthPackageId) {
					item.disabled = true;
					item.tip = this.$t('eip.help.paidByDurationJoinSharedBandwidthNotAllowed');
				}
				if (key === 'REMOVESHARED' && !this.gridData.bandwidthPackageId) {
					item.ifShow = false;
				}
				if (key === 'RENEW' && this.gridData.chargeMode
					=== this.ChargeModeConstant.POSTPAID_BY_DURATION && this.gridData.bandwidthPackageId) {
					item.disabled = true;
					item.tip = this.$t('eip.help.joinSharedBandwidthNotAllowedRenew');
				}
				if (key === 'DELETE' && this.gridData.chargeMode
					=== this.ChargeModeConstant.PREPAID_BY_DURATION) {
					item.disabled = true;
					item.tip = this.$t('eip.help.paidByDurationDeleteNotAllowed')
				}
				if (key === 'DELETE' && this.gridData.status === 'associate' && this.gridData.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION && !this.gridData.bandwidthPackageId && !this.gridData.nat) {
					item.disabled = true;
					item.tip = this.$t('eip.help.boundDeleteNotAllowed')
				}
				if (key === 'DELETE' && this.gridData.nat) {
					item.disabled = true;
					item.tip = this.$t('eip.help.bindNatDeleteNotAllowed')
				}
				if (key === 'DELETE' && this.gridData.bandwidthPackageId) {
					item.disabled = true;
					item.tip = this.$t('eip.help.shareDeleteNotAllowed')
				}
				if (this.disableByChargeStatus && key
					!== 'RENEW' && key !== 'EDITTAG' && key !== 'DELETE') {
					item.disabled = true;
					item.tip = this.$t('privateNetInstance.operations.overdueTip');
				}
				if (!this.gridData.charge.chargeStatus) {
					item.disabled = true;
					item.tip = this.$t('eip.help.noChargeInfo');
				}
				return item;
			});
			for (let i = 0; i < this.availableOperatesArray.length; i++) {
				if (!this.availableOperatesArray[i].ifShow) {
					this.availableOperatesArray.splice(i, 1)
				}
			}
		},
		jumpToUp() {
			this.$router.push({
				name: 'EipList',
				params: { region: this.region }
			});
		},
		jumpToDetail(id, region) {
			this.$router.push({
				path: `/sbw/detail/${id}/${region}`,
				query: {
					regionName: this.getRegionName(region),
					tabName: 'source'
				}
			});
		},
		selectOps(item) {
			switch (item) {
				case EipOperationConstant.BIND: {
					if (item.disabled) {
						return false;
					}
					this.bindDialogVisible = true;
					break;
				}
				case EipOperationConstant.UNBIND: {
					if (item.disabled) {
						return false;
					}
					this.unBindSourcedDialogVisible = true;
					break;
				}
				case EipOperationConstant.MODIFY: {
					if (item.disabled) {
						return false;
					}
					this.modifyDialogVisible = true;
					break;
				}
				case EipOperationConstant.JOINSHARED: {
					if (item.disabled) {
						return false;
					}
					this.joinShareBandwidthDialogVisible = true;
					break;
				}
				case EipOperationConstant.REMOVESHARED: {
					if (item.disabled) {
						return false;
					}
					operations(EipOperationConstant.REMOVESHARED, this, this.gridData, 'detail');
					break;
				}
				case EipOperationConstant.RENEW: {
					if (item.disabled) {
						return false;
					}
					EipPopHelper.operations(EipOperationConstant.RENEW, this, this.gridData, 'detail');
					break;
				}
				case EipOperationConstant.EDITTAG: {
					if (item.disabled) {
						return false;
					}
					this.editTagDialogVisible = true;
					break;
				}
				case EipOperationConstant.DELETE: {
					if (item.disabled) {
						return false;
					}
					this.deleteEipVisible = true;
					break;
				}
			}
		},
		copyToClipboard() {
			this.copyHover = true;
		},
		goBack() {
			this.$router.push({
				path: '/eip/list'
			});
		},
		failToCopy() {
			console.log('Failed to copy texts');
		},
		// 同步绑定资源子组件传输来的dialog是否显示的数据
		syncBindDialogVisibleData(data) {
			this.bindDialogVisible = data;
		},
		// 同步解绑资源子组件传出来的dialog是否展示
		syncUnbindDialog(data) {
			this.unBindSourcedDialogVisible = data;
		},
		syncModifyDialogVisibleData(data) {
			this.modifyDialogVisible = data;
		}
	},

};

</script>

<style lang="scss">
@import '~@/assets/scss/detailCommon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/eip/detail/Detail.vue